import SxDef from '@core/types/SxDef';
import { expandDisplayFlex } from '@core/utils/expandShorthandCss';

const useSx = (sidebar: boolean, sidebarCollapsed: boolean): SxDef => ({
  root: {
    '.main-container': {
      boxSizing: 'border-box',
      maxWidth: '100vw',
      marginLeft: { xs: 0, sm: sidebarCollapsed ? '70px' : '200px' },
      // Padding and max width are owned by PageWrapper.
      flex: 1,
      ...expandDisplayFlex({ d: 'column' }),
      transition: 'all 0.3s',
    },
    '.main-drawer-container': {
      display: { xs: 'block', sm: sidebar ? 'block' : 'none' },
      height: 'calc(100% - 64px)',
      position: 'fixed',
      top: '64px',
      width: {
        xs: '0',
        sm: sidebarCollapsed ? '70px' : '200px',
      },
      transition: 'width 0.3s',
      backgroundColor: (theme) => theme.palette.primary.main,
    },
  },
});
export default useSx;
